<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="320">
        <v-card>
          <v-card-title class="text-h5">
            {{ title }}
          </v-card-title>

          <v-card-text>
            <!-- Are you sure you want to delete this message? -->
            <span v-html="message"></span>
            <!-- {{ message }} -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.native="cancel">
              No
            </v-btn>
            <v-btn color="primary" @click.native="agree">
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ConfirmDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },
    };
  },

  methods: {
    open(title, message) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
